<h2 class="page-title">Multi Hits</h2>

<div class="card-section">
  <div class="panel-row">
    <div class="dh-panel tint-dh1">
      <b>Multi Hits 1</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.multiple_hits.search_items[0].page_source_url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.multiple_hits.search_items[0].page_source"></textarea>
      </div>
    </div>

    <div class="dh-panel tint-dh2">
      <b>Multi Hits 2</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.multiple_hits.search_items[1].page_source_url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.multiple_hits.search_items[1].page_source"></textarea>
      </div>
    </div>
  </div>
</div>

<div class="card-section">
  <div class="mb-3">
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="simpleSearch"
        [(ngModel)]="simple_search" (change)="onSimpleSearchChange()">
      <label class="form-check-label" for="simpleSearch">
        Do results show brand and number (simple search)?
      </label>
    </div>
  </div>

  <table class="data-table">
    <thead>
      <tr>
        <th>Field</th>
        <th class="tint-dh1 text-center">Multi Hits 1 — Target Value</th>
        <th class="tint-dh2 text-center">Multi Hits 2 — Target Value</th>
        <th>Selectors</th>
      </tr>
    </thead>
    <tbody>

      <tr>
        <td>URL 1</td>
        <td class="tint-dh1">
          <form [formGroup]="multi_hit_selector_search">
            <input type="text" formControlName="page_0_url0"
              value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[0].url}}">
          </form>
        </td>
        <td class="tint-dh2">
          <form [formGroup]="multi_hit_selector_search">
            <input type="text" formControlName="page_1_url0"
              value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[0].url}}">
          </form>
        </td>
        <td>
          @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('url')">Show</button>
          }
        </td>
      </tr>

      @if (simple_search) {
        <tr>
          <td>Brand 1</td>
          <td class="tint-dh1">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_0_brand0"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[0].brand}}">
            </form>
          </td>
          <td class="tint-dh2">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_1_brand0"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[0].brand}}">
            </form>
          </td>
          <td>
            @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
              <button class="btn btn-sm btn-secondary" (click)="showSelectors('brand')">Show</button>
            }
          </td>
        </tr>

        <tr>
          <td>Number 1</td>
          <td class="tint-dh1">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_0_number0"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[0].number}}">
            </form>
          </td>
          <td class="tint-dh2">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_1_number0"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[0].number}}">
            </form>
          </td>
          <td>
            @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
              <button class="btn btn-sm btn-secondary" (click)="showSelectors('number')">Show</button>
            }
          </td>
        </tr>
      }

      <tr>
        <td>URL 2</td>
        <td class="tint-dh1">
          <form [formGroup]="multi_hit_selector_search">
            <input type="text" formControlName="page_0_url1"
              value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[1].url}}">
          </form>
        </td>
        <td class="tint-dh2">
          <form [formGroup]="multi_hit_selector_search">
            <input type="text" formControlName="page_1_url1"
              value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[1].url}}">
          </form>
        </td>
        <td>
          @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('url')">Show</button>
          }
        </td>
      </tr>

      @if (simple_search) {
        <tr>
          <td>Brand 2</td>
          <td class="tint-dh1">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_0_brand1"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[1].brand}}">
            </form>
          </td>
          <td class="tint-dh2">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_1_brand1"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[1].brand}}">
            </form>
          </td>
          <td>
            @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
              <button class="btn btn-sm btn-secondary" (click)="showSelectors('brand')">Show</button>
            }
          </td>
        </tr>

        <tr>
          <td>Number 2</td>
          <td class="tint-dh1">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_0_number1"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[0].elements[1].number}}">
            </form>
          </td>
          <td class="tint-dh2">
            <form [formGroup]="multi_hit_selector_search">
              <input type="text" formControlName="page_1_number1"
                value="{{this.data.supplier_implementation.multiple_hits.search_items[1].elements[1].number}}">
            </form>
          </td>
          <td>
            @if (this.data.supplier_implementation.multiple_hits_selectors.selectors.length > 0) {
              <button class="btn btn-sm btn-secondary" (click)="showSelectors('number')">Show</button>
            }
          </td>
        </tr>
      }

    </tbody>
  </table>

  <div class="d-flex justify-content-end align-items-center gap-3 mt-3">
    <span class="status-text">{{ multi_hits_status }}</span>
    <button class="btn btn-primary" (click)="onSubmit_multi_hit_selector_search()">GO!</button>
  </div>
</div>

<!-- selector overlay -->
<div id="overlay" (click)="overlay_off()">
  <div class="selector-modal" (click)="$event.stopPropagation()">
    <div class="selector-modal-header">
      <span id="overlay-title" class="selector-modal-title"></span>
      <button class="btn-close" (click)="overlay_off()"></button>
    </div>
    <div class="selector-modal-body">
      <div id="text"></div>
    </div>
  </div>
</div>
